import { useDeleteConfirmationStore } from "../../store/useDeleteConfirmationStore";

export const useDeleteConfirmationModal = () => {
  const open = useDeleteConfirmationStore((state) => state.openModal);
  const setOpen = useDeleteConfirmationStore((state) => state.setOpenModal);

  const handleSubmit = () => {
    setOpen(false);
  };

  return {
    open,
    setOpen,
    handleSubmit,
  };
};
